<!-- eslint-disable max-len -->
<template>
  <v-skeleton-loader v-if="racesLoading" type="table"></v-skeleton-loader>
  <div v-else>
    <div v-if="!allRaces && !noRacesAvail" >
      <v-simple-table dense fixed-header class="row-pointer"
        style="border-radius: 0px !important" :height="dataTableHeight">
        <thead>
          <tr class="raceDetails_header">
            <th class="text-left" style="max-width:120px">Date</th>
            <th class="text-left" style="max-width:140px;">Venue</th>
            <th style="max-width:60px;" class="text-left">Race</th>
            <th class="text-left">Race Type</th>
            <th class="text-right">Total Placed</th>
            <th class="text-center">Bets</th>
          </tr>
        </thead>
        <tbody style="font-weight:500 !important">
          <tr v-for="race in races" :key="`${race.raceNumber}+${race.track}+${race.meetingType}+${race.meetingDate}`"
            @click="setSelectedMeeting({ meetingId: race.meetingId }),
            setSelectedRace({ race, meeting }),
            clearAllRunners(),
            activerow(race)" :class="{'primary white--text': `${race.raceNumber}+${race.track}+${race.meetingType}+${race.meetingDate}` === selectedItem}">
            <td v-if="race.meetingDate" style="max-width:120px">
              {{format(new Date(race.meetingDate), 'dd MMM yyyy')}}
            </td>
            <td style="max-width:160px;white-space:nowrap;overflow: hidden;text-overflow: ellipsis;">{{race.track}}</td>
            <td class="text-center" style="max-width:20px;">{{race.raceNumber}}</td>
            <td>{{RACE_TYPE[race.meetingType]}}</td>
            <td class="text-right">${{numeral(race.betsValue).format('0,0.00')}}</td>
            <td class="text-center">{{race.betsCount || '0'}}</td>
          </tr>
        </tbody>
      </v-simple-table>
      <div v-for="type in betTypes" :key="type.type">
        <v-divider></v-divider>
        <v-simple-table dense style="border-radius: 0px !important">
          <thead>
          <tr>
            <td><b>{{type.type}}</b></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right">
              <span><b>${{numeral(type.total).format('0,0.00')}}</b></span>
            </td>
            <td class="text-center" style="width: 10%">
              <span><b>{{numeral(type.count).format('0a')}}</b></span>
            </td>
          </tr>
          </thead>
        </v-simple-table>
      </div>
      <v-divider></v-divider>
      <v-simple-table dense style="border-radius: 0px !important">
        <thead>
          <tr>
            <td><b>Totals</b></td>
            <td></td>
            <td></td>
            <td></td>
            <td class="text-right">
              <span><b>${{numeral(allBetsTotalMeeting()).format('0,0.00')}}</b></span>
            </td>
            <td class="text-center" style="width: 10%">
              <span><b>{{numeral(allNoBetsTotalMeeting()).format('0a')}}</b></span>
            </td>
          </tr>
        </thead>
      </v-simple-table>
    </div>
    <div v-else-if="!meetingsLoading && allRaces" style="height:100%;display: flex;justify-content: center;margin-top: 5vh">
      <v-card style="text-align: center" height="auto" width="50vw">
        <div class="mb-2 mt-2">
          <h2 class="mb-2 headline">Please select a meeting from the list</h2>
          <div v-if="!bookiesLoading">
            <h2 class="title">Totals for selected dates</h2>
            <h3 class="subtitle-1">Bet Value: <b>${{numeral(allBetsTotalRaces()).format('0,0.00')}}</b></h3>
            <h3 class="subtitle-1">Bet Count: <b>{{numeral(allNoBetsTotalRaces()).format('0a')}}</b></h3>
          </div>
          <v-skeleton-loader v-else type="article"></v-skeleton-loader>
        </div>
      </v-card>
    </div>
    <div v-else-if="!meetingsLoading && noRacesAvail" style="height:100%;display: flex;justify-content: center;margin-top: 5vh">
      <v-card style="text-align: center" height="auto" width="50vw">
        <div class="mb-2 mt-2">
          <h2 class="mb-2 headline">This meeting has no recorded bets</h2>
          <div>
            <h2 class="title">Please select another meeting from the list</h2>
          </div>
        </div>
      </v-card>
    </div>
    <div v-else-if="meetingsLoading">
      <v-skeleton-loader type="article"></v-skeleton-loader>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import numeral from 'numeral'
import { format } from 'date-fns'
import { RACE_TYPE } from '../../common/constants'
import { loaders } from '@/store'

export default {
  name: 'RaceDetails',
  props: {
    races: {
      type: Array,
      default: () => []
    },
    allRaces: {
      type: Boolean
    },
    items: {
      type: Array,
      default: () => []
    },
    bookiesrace: {
      type: Array,
      default: () => []
    },
    dataTableHeight: {
      type: Number
    }
  },
  data () {
    return {
      numeral,
      RACE_TYPE,
      format,
      selectedItem: -1
    }
  },
  methods: {
    ...mapActions(['setSelectedRace', 'setSelectedMeeting', 'fetchRunners']),
    activerow (race) {
      this.selectedItem = `${race.raceNumber}+${race.track}+${race.meetingType}+${race.meetingDate}`
    },
    clearAllRunners () {
      this.$store.commit('clearRunners')
      this.fetchRunners()
    },
    allBetsTotal () {
      return this.items.reduce((acc, curr) => acc + curr.total, 0)
    },
    allBetsTotalMeeting () {
      return this.bookiesrace.reduce((acc, curr) => acc + curr.total, 0)
    },
    allNoBetsTotalMeeting () {
      return this.bookiesrace.reduce((acc, curr) => acc + curr.count, 0)
    },
    allBetsTotalRaces () {
      let totalBets = 0
      this.allBookies.forEach((b) => {
        if (b.total) {
          totalBets += b.total
        }
      })
      return numeral(totalBets).format('0,0.00')
    },
    allNoBetsTotalRaces () {
      let totalBets = 0
      this.allBookies.forEach((b) => {
        if (b.count) {
          totalBets += b.count
        }
      })
      return numeral(totalBets).format('0,0.00')
    }
  },
  computed: {
    ...mapGetters(['getSelectedMeeting', 'getSelectedRace']),
    ...mapState(['bets', 'loading', 'allBookies', 'noRacesAvail', 'betsByType']),
    betTypes () {
      const filteredBetTypes = this.betsByType?.filter((a) => a.type !== 'win' && a.type !== 'place')
      return filteredBetTypes
    },
    racesLoading () {
      return this.loading[loaders.RACES]
    },
    meetingsLoading () {
      return this.loading[loaders.MEETINGS]
    },
    bookiesLoading () {
      return this.loading[loaders.BOOKIE_BETS]
    },
    meeting () {
      return this.getSelectedMeeting || {}
    },
    race () {
      return this.getSelectedRace || {}
    }
  }
}
</script>

<style scoped>
.raceDetails_header {
  height: 56px;
  white-space: nowrap;
  /* background-color: black; */
}
.raceDetails_header th {
  color: white;
}
.row-pointer >>> tbody tr :hover {
  cursor: pointer;
}
</style>
